/**
 * Include your custom JavaScript here.
 *
 * Hooks disponíveis no tema:
 *   document.addEventListener('product:added', fn)  // produto adicionado ao carrinho
 *   document.addEventListener('cart:refresh', fn)   // mini-cart atualizado
 *   document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
 */

/* =========================================================================
 * Brinde por quantidade de caixas de lente.
 * Config vem de window.__brindeConfig (injetada no theme.liquid a partir do
 * metafield da loja `brinde.config`, editável pelo painel do app Checkout BR).
 *
 * ATENCAO: a Function `brinde-lentes` NAO esta ativa (Functions exigem Shopify
 * Plus em app de distribuicao custom). O preco R$0 vem do proprio preco da
 * variante de brinde. Portanto ESTE script e a unica trava de quantidade —
 * ele precisa reconciliar o carrinho de forma defensiva.
 *
 * Bug corrigido (pedido #4005): a deduplicacao so enxergava linhas com a
 * propriedade `_gift`. Um brinde adicionado pelo proprio cliente (botao de
 * compra rapida num card de colecao/busca, que nao envia propriedades) ficava
 * invisivel, e o script adicionava um segundo => 2 brindes. Agora casamos as
 * linhas pelo variant_id, independente das propriedades.
 * ========================================================================= */
(function () {
  var CFG = window.__brindeConfig;
  if (!CFG || CFG.enabled !== true || !Array.isArray(CFG.tiers) || !CFG.tiers.length) return;

  var tiers = CFG.tiers
    .map(function (t) {
      var raw = String(t.gift_variant_id || '');
      var match = raw.match(/(\d+)\s*$/);
      return {
        min: Number(t.min_boxes) || 0,
        variantId: match ? Number(match[1]) : Number(raw) || 0,
        label: t.label || 'Brinde grátis',
      };
    })
    .filter(function (t) {
      return t.min > 0 && t.variantId;
    });
  if (!tiers.length) return;

  var syncing = false;

  // IDs de TODAS as variantes de brinde configuradas.
  var giftVariantIds = tiers.map(function (t) {
    return t.variantId;
  });

  // Marcado como brinde pelo nosso script (usado só para preferir esta linha
  // ao consolidar duplicatas — nunca como critério de deduplicação).
  function hasGiftProp(item) {
    return !!(item.properties && item.properties._gift);
  }

  // Qualquer linha cuja variante seja de brinde, TENHA OU NÃO a propriedade.
  function isGiftVariant(item) {
    return giftVariantIds.indexOf(item.variant_id) !== -1;
  }

  function isLens(item) {
    // cart.js expõe product_type; as lentes da loja têm type contendo "lente".
    return String(item.product_type || '').toLowerCase().indexOf('lente') !== -1;
  }

  function countBoxes(cart) {
    var n = 0;
    cart.items.forEach(function (it) {
      if (!isGiftVariant(it) && isLens(it)) n += it.quantity;
    });
    return n;
  }

  // Todas as linhas dessa variante de brinde, com as marcadas por nós primeiro
  // (preserva o rastro `_gift` quando houver duplicata).
  function giftLines(cart, variantId) {
    return cart.items
      .filter(function (it) {
        return it.variant_id === variantId;
      })
      .sort(function (a, b) {
        return (hasGiftProp(b) ? 1 : 0) - (hasGiftProp(a) ? 1 : 0);
      });
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function addGift(tier) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: tier.variantId, quantity: 1, properties: { _gift: tier.label } }] }),
    });
  }

  function changeGift(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: String(key), quantity: quantity }),
    });
  }

  async function sync() {
    if (syncing) return;
    syncing = true;
    try {
      var cart = await getCart();
      var boxes = countBoxes(cart);
      var changed = false;

      for (var i = 0; i < tiers.length; i++) {
        var tier = tiers[i];
        var lines = giftLines(cart, tier.variantId);
        var qualifies = boxes >= tier.min;

        if (!qualifies) {
          // Não tem direito: remove TODA linha dessa variante de brinde,
          // inclusive as que o próprio cliente tenha adicionado.
          for (var r = 0; r < lines.length; r++) {
            await changeGift(lines[r].key, 0);
            changed = true;
          }
        } else if (!lines.length) {
          await addGift(tier);
          changed = true;
        } else {
          // Tem direito: mantém exatamente UMA linha com quantidade 1
          // e descarta o resto (duplicatas por propriedades diferentes).
          if (lines[0].quantity !== 1) {
            await changeGift(lines[0].key, 1);
            changed = true;
          }
          for (var d = 1; d < lines.length; d++) {
            await changeGift(lines[d].key, 0);
            changed = true;
          }
        }
      }

      if (changed) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }
    } catch (e) {
      /* silencioso — a Function ainda garante o preço correto */
    } finally {
      syncing = false;
    }
  }

  // Reage a adições do cliente (não a cart:refresh, pra não entrar em loop com o próprio sync).
  document.addEventListener('product:added', function () {
    setTimeout(sync, 150);
  });

  // Sincroniza no carregamento (ex.: página do carrinho / drawer aberto).
  if (document.readyState !== 'loading') {
    sync();
  } else {
    document.addEventListener('DOMContentLoaded', sync);
  }
})();
